<div
    class="checkout-options-layout"
    [ngClass]="{
        'checkout-options-layout--sidebar-fixed': !isSidebarSticky,
        'checkout-options-layout--without-car-preview': !withCarPreview,
        'checkout-options-layout--without-top-margin': isPrecededByActionBanner || !withCarPreview
    }"
>
    <div class="checkout-options-layout__car-preview-fields">
        <mg-checkout-referral-banner [deal$]="deal$"></mg-checkout-referral-banner>
        <ng-content select="[mg-car-preview-fields]"></ng-content>
    </div>

    <div class="checkout-options-layout__car-preview">
        <ng-container *ngIf="deal$ | async">
            <mg-checkout-referral-banner [deal$]="deal$"></mg-checkout-referral-banner>
            <mg-preview-tesla [deal$]="deal$"></mg-preview-tesla>
        </ng-container>
    </div>

    <div class="checkout-options-layout__remaining-fields" #remainingFieldsElement>
        <ng-content select="[mg-remaining-fields]"></ng-content>
    </div>

    <div
        class="checkout-options-layout__sidebar"
        [ngClass]="{ 'checkout-options-layout__sidebar--open-on-mobile': isMobileInfoPanelOpen }"
    >
        <div class="checkout-options-layout__sidebar-inner">
            <mg-checkout-sidebar
                [deal$]="deal$"
                [isOpenOnMobile]="isMobileInfoPanelOpen"
                [modelName]="modelName"
            ></mg-checkout-sidebar>
        </div>
    </div>
</div>
